var exports = {
  "kL": "x804f0401--c5f1e3--container",
  "DD": "x804f0401--c5f1e3--title",
  "Ud": "x804f0401--c5f1e3--overall-rating",
  "VQ": "x804f0401--c5f1e3--ratings",
};

module.exports = exports;
